import React, {Fragment, useEffect, useState} from "react";
import useListboxFetch from "root/ReactHookForm/ui/useListboxFetch";
import SpinnerDiv from "ui/ReactSpinnerDiv";
import {CommonDropdown} from "root/s360components/ReactHookForm/ui/CommonDropdown";

const DropdownLeas = ({setLeaDetails}) =>
{

    const onChange = (data) =>
    {
        setLeaDetails({lea_id: data.value , lea_name: data.label})
    }

    const fields = { url: '/school360/leas', keyFieldName: 'lea_id', labelFieldName: 'lea_name' }

    const [ loading, items ] = useListboxFetch( fields ) ;

    return (
        <Fragment>
            { loading === true && <div className='form-control'><SpinnerDiv/></div> }
            { loading === false && <CommonDropdown items={items}  onChange={onChange} placeholder={"Northumberland"} /> }
        </Fragment>
    )
}

export default DropdownLeas;